export default __webpack_public_path__ + "2a2401e83dd4f0ddf32fb9df27ab65f0.png";